import CryptoJS from 'crypto-js';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const resendEmail = {
  namespaced: true,

  state() {
    return {
      allMerchants: [],
      totalMerchants: 0,
      totalPage: 0,
      loading: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      merchant: null,
      selectedData: [],
      broadcastAll: false,
      search: {},
      dataEdit: null,
      onUpload: false,
      uploadProgress: 0,
    };
  },

  mutations: {
    setMerchants(state, { payload }) {
      state.allMerchants = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearMerchants(state) {
      state.allMerchants = [];
      state.totalMerchants = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalMerchants(state, { payload }) {
      state.totalMerchants = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setSelectedData(state, payload) {
      state.selectedData = payload;
    },

    setBroadcastAll(state, payload) {
      state.broadcastAll = payload;
    },

    setSearch(state, payload) {
      state.search = payload;
    },

    setDataEdit(state, dataEdit) {
      state.dataEdit = dataEdit;
    },

    clearDetail(state) {
      state.selectedData = [];
      state.broadcastAll = false;
      state.search = {};
    },

    setOnUpload(state, onUpload) {
      state.onUpload = onUpload;
    },

    setUploadProgress(state, uploadProgress) {
      state.uploadProgress = uploadProgress;
    },
  },

  actions: {
    async fetchDataLog(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      ctx.commit('clearMerchants');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            sort_by +
              itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/resend_email/resend-email/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 200) {
        ctx.commit('setTotalMerchants', {
          payload: responseData,
        });
        ctx.commit('setMerchants', { payload: responseData });
      }
    },

    async resendEmail(ctx, { id }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/resend_email/resend-email/send-email`;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code == 200) {
        resVal = responseData;
      }
      return resVal;
    },
  },
};
export default resendEmail;
